module.exports = __webpack_public_path__ + "img/ClickForSound_5.411e54ba.png";